import React from 'react';
import { Modal } from 'react-responsive-modal';
import { Typography, Box, Grid } from '@mui/material';
import { MasterMessage } from '../../../../../masters/masterMessages';
import FieldText from '../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import Loading from '../../../../components/general/loading/loading';
import { DependencyForm } from './DependencyForm';
import { ModalQuestionProps } from './types';
import {
    typeQuestions,
    typesIcon,
    typesSupported,
    subtypeQuestions,
} from './constants';
import { Buttons } from './Buttons';
import { FieldSwitch } from '../../../../components/general/fields/Switch';

const ModalQuestionComponent: React.FC<
    ModalQuestionProps & {
        formik: any;
        questionDependency: any;
        dependencies: any[];
    }
> = ({
    open,
    onClose,
    loading,
    idQuestion,
    formik,
    questionDependency,
    dependencies,
    isTextTypeQuestion,
}) => {
    const { questions }: any = MasterMessage.surveys;
    const typeIcon =
        typesIcon.find((i) => i.id === formik.values.icon) || typesIcon[0];

    return (
        <Modal
            open={open}
            onClose={() => onClose(false)}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            <Box>
                <Typography
                    color="primary"
                    component="h3"
                    sx={{
                        fontSize: { lg: 27, xs: 23 },
                        mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                    }}
                >
                    {idQuestion ? questions.titleEdit : questions.titleNew}
                </Typography>
                <hr />
                <Box mt={3} px={1}>
                    <Grid
                        container
                        spacing={{ xs: 1, md: 1 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        {loading ? (
                            <Loading />
                        ) : (
                            <>
                                <Grid item xs={12} mt={1}>
                                    <FieldSelect
                                        data={typeQuestions}
                                        label="Tipo Pregunta"
                                        name="type"
                                        size="small"
                                        required={true}
                                        disabled={Boolean(idQuestion)}
                                        touched={formik.touched.type}
                                        errors={formik.errors.type}
                                        value={formik.values.type}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                {isTextTypeQuestion && (
                                    <Grid item xs={12} mt={1}>
                                        <FieldSelect
                                            data={subtypeQuestions}
                                            label="Subtipo Pregunta"
                                            name="subtype"
                                            size="small"
                                            required={isTextTypeQuestion}
                                            disabled={Boolean(idQuestion)}
                                            touched={formik.touched.subtype}
                                            errors={formik.errors.subtype}
                                            value={formik.values.subtype}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} mt={1}>
                                    <FieldText
                                        label="Descripción"
                                        name="description"
                                        size="small"
                                        required={true}
                                        rows={3}
                                        touched={formik.touched.description}
                                        errors={formik.errors.description}
                                        value={formik.values.description}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                {formik.values.type !== 'label' && (
                                    <Grid item xs={12} md={5.5} mx={0.5}>
                                        <FieldSwitch
                                            name="required"
                                            mainLabel="Obligatorio"
                                            checked={formik.values.required}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {formik.values.type ===
                                    'validation-reference' && (
                                    <Grid item xs={12} mt={1}>
                                        <FieldSwitch
                                            name="gateSurveyUntilValidated"
                                            mainLabel="Encuesta tras validar"
                                            checked={
                                                formik.values
                                                    .gateSurveyUntilValidated
                                            }
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {(formik.values.type === 'linear' ||
                                    formik.values.type === 'linear-label') && (
                                    <>
                                        <Grid item xs={10} mt={1}>
                                            <FieldSelect
                                                data={typesIcon}
                                                label="Icono"
                                                name="icon"
                                                size="small"
                                                required={true}
                                                touched={formik.touched.icon}
                                                errors={formik.errors.icon}
                                                value={formik.values.icon}
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            mt={1}
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            {typeIcon?.icon}
                                            {typeIcon?.icon2}
                                        </Grid>
                                    </>
                                )}
                                {formik.values.type !== 'label' &&
                                    formik.values.type !==
                                        'validation-reference' &&
                                    typesSupported[formik?.values?.type] && (
                                    <Grid item xs={12} md={5.5} mx={0.5}>
                                        <FieldSwitch
                                            name="why"
                                            mainLabel="¿Por qué?"
                                            checked={formik.values.why}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {formik.values.type !== 'label' &&
                                    dependencies.length > 0 && (
                                    <Grid item xs={12} md={5.5} mx={0.5}>
                                        <FieldSwitch
                                            name="dependency"
                                            mainLabel="Dependencia"
                                            checked={
                                                formik.values.dependency
                                            }
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                )}
                                {formik.values.type !== 'label' &&
                                    formik.values.dependency &&
                                    dependencies.length > 0 && (
                                    <DependencyForm
                                        formik={formik}
                                        dependencies={dependencies}
                                        questionDependency={
                                            questionDependency
                                        }
                                    />
                                )}
                            </>
                        )}
                        <Buttons
                            onSave={formik.handleSubmit}
                            onClose={() => onClose(false)}
                        />
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalQuestionComponent;
